import { useCallback, useEffect, useState } from 'react'

import { Violation } from '@/entities/schedules/models/Violation'
import { OLMSApiService } from '@/shared/apis'
import { useAppSelector } from '@/shared/store'

export const useViolationData = () => {
  const currentScreen = useAppSelector(state => state.userInterface.currentScreen)
  const [violations, setViolations] = useState<Violation[]>([])
  const [loading, setLoading] = useState(false)

  const fetchViolations = useCallback(async () => {
    if (!currentScreen) return
    setLoading(true)

    let endpoint = '/planning/violation'

    if (currentScreen === 'runsheet') {
      endpoint = 'runsheet/violation'
    }

    const data = await OLMSApiService.get<Violation[]>(endpoint)

    setViolations(data || [])
    setLoading(false)
  }, [currentScreen])

  useEffect(() => {
    fetchViolations()
  }, [currentScreen, fetchViolations])

  return {
    loading,
    violations,
    setViolations,
  }
}
